var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择","clearable":""},on:{"change":_vm.change},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }